import React from "react";
import { PopupButton } from "react-calendly";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

function ServiceCard(props) {
  return (
    <div>
      <Card className="project-card-view">
        <Card.Img variant="top" src={props.imgPath} alt="service-img" />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text>
            {props.description}
          </Card.Text>
          <hr />
          
          <Button
          variant="primary"
          href={props.bookLink}
          target="_blank"
          style={{
            marginBottom:"10px"
          }}
          >
            Book a Service
          </Button>
          {"\n"}
          {"\n"}
          <PopupButton
            url="https://calendly.com/raymondyounes2"
            rootElement={document.getElementById("root")}
            className="btn btn-primary"
            text="Book Meeting"
          >
          </PopupButton>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ServiceCard;
